<template>
    <div>
        <el-dialog
            :visible.sync="dialog.show"
            width="35%"
            append-to-body
            :show-close="false"
            :close-on-click-modal="false"
            class="book-calendar-pick-dialog-btm-kan-style"
            >
                <el-row>
                    <el-col class="head-font" style="padding-bottom: 20px;">
                        <span>เลือกวันเข้ารับ</span>
                    </el-col>
                </el-row>
                <el-row style="padding-bottom: 20px;">
                    <el-col :span="24">
                        <el-autocomplete
                            v-model="shopSearchText"
                            placeholder="ใส่ชื่อร้านค้า"
                            style="width: 100%"
                            :trigger-on-focus="false"
                            suffix-icon="el-icon-search"
                            :fetch-suggestions="querySearchAsync"
                            @select="selectShopAddressHandler($event)">
                        </el-autocomplete>
                    </el-col>
                </el-row>
                <div class="book-dialog">
                    <el-form :rules="bookingRules" label-position="left" ref="bookingForm" :model="bookingDataDetailForm">
                        <el-form-item label="รูปแบบการส่ง :" prop="bookingCourier" label-width="150px">
                            <el-select
                                v-model="bookingDataDetailForm.bookingCourier"
                                :disabled="true">
                            <el-option
                                v-for="item in shipflowPickUpTypeList"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="เลือกบริการขนส่ง :" prop="deliveryForm" label-width="150px" class="booking-calendar-pick-date-dialog-select-courier-kan-style">
                            <el-select
                                v-model="bookingDataDetailForm.deliveryForm">
                            <el-option
                                v-for="item in courierList"
                                :key="item.id"
                                :label="item.label"
                                :value="item.courierId"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-row>
                                <el-col :span="10">
                                    <el-row>
                                        <el-col class="line" :span="4"><i class="el-icon-time"></i></el-col>
                                        <el-col :span="20">
                                        <el-form-item prop="timeAt">
                                            <el-time-picker
                                                v-model="bookingDataDetailForm.timeAt"
                                                value-format="HH:mm"
                                                format="HH:mm"
                                                placeholder="10.00 pm"
                                                style="width: 100%;"
                                            >
                                            </el-time-picker>
                                        </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="14">
                                    <el-row>
                                        <el-col class="line text-center" :span="8">เริ่มวันที่ :</el-col>
                                        <el-col :span="16">
                                        <el-form-item prop="startAt">
                                            <el-date-picker
                                                v-model="bookingDataDetailForm.startAt"
                                                :picker-options="datePickerOptions"
                                                :default-value="new Date()"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                                placeholder="Pick a date"
                                                style="width: 100%;">
                                            </el-date-picker>
                                        </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <div style="border: 0.5px solid #e0e0e0;">
                        </div>
                        <el-form-item label="วันที่รถเข้ารับสินค้า :">
                            <span>{{ getShipflowTypeName(bookingDataDetailForm.bookingCourier) }}</span>
                        </el-form-item>
                    </el-form>
                    <el-form :model="bookingAllDataForm">
                        <el-form-item label="สถานที่เข้ารับ :">
                            <el-row
                            type="flex"
                            align="middle"
                            justify="center">
                                <el-col :span="20">
                                    <el-form-item class="clearfix customer-text-left">
                                        <span><i class="material-icons booking-calendar-pick-date-edit-icon-kan-style" :disabled="!hasAddressInfo" :class="{'booking-calendar-disable-day-kan-style':!hasAddressInfo}" @click="editShopAddressHandler()">edit</i></span>
                                        <span class="text-color-gray">{{hasAddressInfo? formatShipflowPickUpAddress(bookingAllDataForm.address): ''}}</span>
                                    </el-form-item>
                                    <el-form-item class="custom-infor-pad">
                                        <el-tag
                                            v-for="(shop, idx) in bookingAllDataForm.address.shops_with_pickup_address"
                                            :key="idx"
                                            type="info"
                                            style="margin: 5px 15px 5px 0px;"
                                        >
                                            {{ shop.name }}
                                        </el-tag>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <span v-if="isAddressNotice" style="color: red; font-size: 12px;">กรุณาเลือกที่อยู่จัดส่ง</span>
                        <el-form-item class="text-center">
                            <el-button @click="dialog.show = false">ยกเลิก</el-button>
                            <el-button type="primary" @click="submitForm('bookingForm')">ตกลง</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <customer-address-form
                    :bookingAllDataForm.sync="bookingAllDataForm"
                    :detail.sync="userInfo"
                    :isCheckStatus.sync="isCheckStatus"/>
        </el-dialog>
    </div>
</template>
<script>
import fgApi from '@/services/fillgoods'
import CustomerAddressForm from '@/components/Customer/CustomerAddress/CustomerAddressForm.vue'

export default {
    name: 'BookingCalendarPickDateDialog',
    components: {
        'customer-address-form': CustomerAddressForm
    },
    props: {
        dialog: {
            type: Object,
            default: () => {
                return {
                    show: false
                }
            }
        }
    },
    data () {
        return {
            bookingAllDataForm: {
                address: {
                    address: '',
                    province: '',
                    district: '',
                    sub_district: '',
                    zipcode: '',
                    shops_with_pickup_address: ''
                }
            },
            bookingDataDetailForm: {
                bookingCourier: 4,
                deliveryForm: '',
                startAt: '',
                timeAt: ''
            },
            isAddressNotice: false,
            bookingRules: {
                bookingCourier: [
                    { required: true, message: 'กรุณาเลือกรูปแบบการขนส่ง', trigger: 'change' }
                ],
                deliveryForm: [
                    { required: true, message: 'กรุณาเลือกบริการขนส่ง', trigger: 'change' }
                ],
                startAt: [
                    { required: true, message: 'กุณาเลือกวันเริ่มขนส่ง', trigger: 'change' }
                ],
                timeAt: [
                    { required: true, message: 'กรุณาเลือกเวลาเข้ารับ', trigger: 'change' }
                ]
            },
            shopSearchText: '',
            shopAddressInfo: [],
            isCheckStatus: {
                dialogAddAddress: false,
                addressLog: {},
                checkIndexAddress: false
            },
            courierList: [],
            userInfo: {
                data: {
                    userId: '',
                    userCode: ''
                }
            },
            loading: false,
            timeout: null,
            datePickerOptions: {
                disabledDate: (date) => {
                    return date < this.$dayjs(new Date()).subtract(1, 'day')
                }
            }
        }
    },
    computed: {
        hasAddressInfo () {
            return (this.bookingAllDataForm.address.address !== '' || this.bookingAllDataForm.address.province !== '' || this.bookingAllDataForm.address.district !== '' || this.bookingAllDataForm.address.sub_district !== '' || this.bookingAllDataForm.address.zipcode !== '' || this.bookingAllDataForm.address.shops_with_pickup_address !== '')
        }
    },
    watch: {
        'dialog.show' (status) {
            if (status) {
                this.$nextTick(() => {
                    this.$refs['bookingForm'].clearValidate()
                    this.isAddressNotice = false
                    this.bookingDataDetailForm.startAt = this.$dayjs().format('YYYY-MM-DD')
                })
            } else {
                this.$refs['bookingForm'].clearValidate()
                this.shopSearchText = ''
                this.bookingAllDataForm = {
                    address: {
                        address: '',
                        province: '',
                        district: '',
                        sub_district: '',
                        zipcode: '',
                        shops_with_pickup_address: ''
                    }
                }
                this.bookingDataDetailForm = {
                    bookingCourier: 4,
                    deliveryForm: '',
                    startAt: '',
                    timeAt: ''
                }
            }
        }
    },
    methods: {
        async getBookingCourier (userId) {
            let param = {
                user_id: userId
            }
            try {
                let res = await fgApi.courier.getBookingCourierProvider(param)
                if (res.success) {
                    let courierListArr = []
                    for (let index in res.data) {
                        courierListArr.push({
                            id: index,
                            label: res.data[index].courierName,
                            courierId: res.data[index].courierId
                        })
                    }
                    let filterCourier = []
                    console.log('ARRAY:', this.shipFlowCourierList)
                    for (let index in this.shipFlowCourierList) {
                        let hasCourier = courierListArr.filter(e => e.courierId === this.shipFlowCourierList[index].courierId)
                        if (hasCourier.length > 0) {
                            filterCourier.push(hasCourier[0])
                        }
                    }
                    this.courierList = filterCourier
                    // console.log('this.courierList', this.courierList)
                }
            } catch (error) {
                this.$message.error(error.error)
            }
        },
        async querySearchAsync (queryString, cb) {
            await this.searchAddressWithShopName(queryString)
            this.shopAddressInfo.map(e => { e.value = e.shop_name })
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                cb(this.shopAddressInfo)
            }, 500)
        },
        async searchAddressWithShopName (text) {
            this.loading = true
            try {
                let param = {
                    search: text
                }
                let res = await fgApi.user.searchPickupAddressWithShop(param)
                if (res.success) {
                    this.shopAddressInfo = res.data
                } else {
                    this.$message.error('Failed')
                }
            } catch (error) {
                this.$message.error(error)
            }
            this.loading = false
        },
        async editShopAddressHandler () {
            this.loading = true
            try {
                let params = {
                    pickup_address_id: this.bookingAllDataForm.address.pickup_address_id,
                    user_id: this.userInfo.data.userId
                }
                let res = await fgApi.user.getPickupAddressWithShop(params)
                if (res.success) {
                    this.isCheckStatus.addressLog = res.data
                    this.isCheckStatus.dialogAddAddress = true
                    this.isCheckStatus.checkIndexAddress = true
                }
            } catch (error) {
                this.$message.error(error)
            }
            this.loading = false
        },
        async selectShopAddressHandler (item) {
            this.getBookingCourier(item.pickup_address.user_id)
            this.bookingAllDataForm = {
                address: {
                    address: item.pickup_address.address,
                    province: item.pickup_address.province,
                    district: item.pickup_address.district,
                    sub_district: item.pickup_address.sub_district,
                    zipcode: item.pickup_address.zipcode,
                    pickup_address_id: item.pickup_address.pickup_address_id,
                    shops_with_pickup_address: item.pickup_address.shops_with_pickup_address
                }
            }
            this.userInfo.data.userId = item.pickup_address.user_id
            this.userInfo.data.userCode = item.user_code
            this.isAddressNotice = false
        },
        async submitForm (ruleForm) {
            this.loading = true
            try {
                this.$refs[ruleForm].validate(async (valid) => {
                    if (valid && this.hasAddressInfo) {
                        this.isAddressNotice = false
                        let params = {
                            type: this.bookingDataDetailForm.bookingCourier,
                            courier_id: this.bookingDataDetailForm.deliveryForm,
                            pickup_time: this.bookingDataDetailForm.timeAt,
                            start_date: this.bookingDataDetailForm.startAt,
                            pickup_address_id: this.bookingAllDataForm.address.pickup_address_id,
                            is_active: true
                        }
                        let res = await fgApi.courier.createCourierBooking(params)
                        if (res.success) {
                            this.$message.success('Booking calendar was created!!')
                            this.dialog.show = false
                        }
                    } else {
                        this.isAddressNotice = !this.hasAddressInfo
                    }
                })
            } catch (error) {
                this.$message.error(error)
            }
            this.loading = false
        }
    }
}
</script>
<style lang="scss">
    .booking-calendar-pick-date-edit-icon-kan-style{
        float: right;
        font-size: 25px;
        cursor: pointer;
    }
    .booking-calendar-disable-day-kan-style{
        pointer-events: none
    }
    .booking-calendar-pick-date-dialog-select-courier-kan-style{
        .el-form-item__content{
            .el-form-item__error{
                padding-left: 35%;
            }
        }
    }
    .book-calendar-pick-dialog-btm-kan-style{
        text-align: center;
        .head-font{
            font-weight: bold;
            font-size: 20px;
        }
    }
</style>
